import React from "react";
import Footer from "../Footer";

const TermsAndConditions = (props) => {
  return (
    <>
      <div style={containerStyle}>
        <h1 style={headingStyle}>Shipping & Delivery Policies</h1>

        <h2 style={subHeadingStyle}>What are the delivery charges?</h2>
        <p style={textStyle}>
          Delivery charges on Kiko Live vary based on the individual seller. As
          Kiko Live is a platform providing visibility for sellers, each seller
          may determine their own shipping policies.
        </p>
        <p style={textStyle}>
          In some cases, sellers may apply nominal delivery charges for
          low-value items to offset shipping costs. Please refer to your order
          summary for the specific delivery charges for each product.
        </p>

        <h2 style={subHeadingStyle}>
          Why might the delivery date differ from the expected delivery window?
        </h2>
        <p style={textStyle}>
          Occasionally, holidays or non-operational days for courier partners
          may affect the expected delivery time. This could cause a one-day
          delay. Additionally, certain sellers and logistics partners may not
          operate on Sundays, which can also impact delivery timelines.
        </p>

        <h2 style={subHeadingStyle}>What is the estimated delivery time?</h2>
        <p style={textStyle}>
          Sellers aim to process and ship orders within the timeframe provided
          when the order is placed. Please note that business days exclude
          public holidays and Sundays.
        </p>
        <p style={textStyle}>
          Estimated delivery times depend on several factors, including:
        </p>
        <ul style={listStyle}>
          <li>The seller fulfilling the order</li>
          <li>Product availability</li>
          <li>The delivery location</li>
          <li>Seller’s shipping procedures</li>
        </ul>

        <h2 style={subHeadingStyle}>
          Are there any hidden charges (sales tax, etc.)?
        </h2>
        <p style={textStyle}>
          There are no hidden charges on Kiko Live. The listed prices are final
          and include all costs. However, shipping, delivery, or packaging
          charges may apply, depending on the seller's shipping policy.
        </p>

        <h2 style={subHeadingStyle}>
          Why does the delivery time vary for different sellers?
        </h2>
        <p style={textStyle}>
          Delivery times may vary due to factors such as the seller’s location,
          the availability of the product, the shipping destination, and the
          courier’s delivery time. Enter your postal code on the product page
          for a more accurate delivery estimate.
        </p>

        <h2 style={subHeadingStyle}>
          The seller does not ship to my location. Why?
        </h2>
        <p style={textStyle}>
          To check if an item can be delivered to your location, enter your
          postal code on the product page. Delivery options depend on:
        </p>
        <ul style={listStyle}>
          <li>The seller’s ability to ship to your location</li>
          <li>Any legal shipping restrictions</li>
          <li>Availability of reliable courier partners in your region</li>
        </ul>

        <h2 style={subHeadingStyle}>
          Why is Cash on Delivery (CoD) not available on Kiko Live under ONDC?
        </h2>
        <p style={textStyle}>
          Cash on Delivery is not available because Kiko Live’s logistics
          partners currently do not support this payment method under the ONDC
          infrastructure.
        </p>

        <h2 style={subHeadingStyle}>
          I need to return an item. How do I arrange for a pick-up?
        </h2>
        <p style={textStyle}>
          Returns are easy on Kiko Live. To initiate a return, contact the
          relevant seller or Kiko Live’s support team for assistance. Where
          possible, sellers or logistics partners will arrange for a pick-up. If
          a pick-up cannot be arranged, you may return the item using a
          third-party courier, with return fees typically covered by the seller.
        </p>

        <h2 style={subHeadingStyle}>
          I received a delivery confirmation but didn’t get my order. What
          should I do?
        </h2>
        <p style={textStyle}>
          If you received a delivery confirmation but did not receive your
          order, please report the issue to the relevant seller or Kiko Live
          within 24 hours for investigation.
        </p>

        <h2 style={subHeadingStyle}>
          What do the different stock status tags mean?
        </h2>
        <ul style={listStyle}>
          <li>
            <strong>In Stock:</strong> Items are available for shipment, with
            delivery timelines based on your location's postal code (usually 2-3
            business days for most areas).
          </li>
          <li>
            <strong>Out of Stock:</strong> Items are unavailable for purchase
            until the seller updates its inventory.
          </li>
        </ul>

        <h2 style={subHeadingStyle}>
          Does Kiko Live offer international delivery under ONDC?
        </h2>
        <p style={textStyle}>
          Currently, Kiko Live does not provide international shipping.
          Purchases can be made using credit or debit cards issued in select
          countries, but delivery addresses must be within the regions supported
          by ONDC.
        </p>
      </div>
      <Footer />
    </>
  );
};

const containerStyle = {
  fontFamily: "Arial, sans-serif",
  margin: "20px auto",
  padding: "20px",
  maxWidth: "800px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const headingStyle = {
  textAlign: "center",
  color: "#333",
  marginBottom: "20px",
};

const subHeadingStyle = {
  color: "#444",
  margin: "15px 0 10px 0",
  fontSize: "18px",
  fontWeight: "bold",
};

const textStyle = {
  lineHeight: "1.6",
  color: "#555",
  marginBottom: "10px",
};

const listStyle = {
  marginLeft: "20px",
  color: "#555",
  lineHeight: "1.6",
};

export default TermsAndConditions;
